import secureLocalStorageModule from "react-secure-storage";

const secureLocalStorage = (secureLocalStorageModule as unknown as {default?: typeof secureLocalStorageModule}).default ?? secureLocalStorageModule;

export class AuthenticationLocalService {
    setAccessToken(accessToken: string) {
        secureLocalStorage.setItem("accessToken", accessToken);
    }
    
    setRefreshToken(refreshToken: string) {
        secureLocalStorage.setItem("refreshToken", refreshToken);
    }
    
    getAccessToken(): string | null {
        return secureLocalStorage.getItem("accessToken") as string | null;
    }
    
    getRefreshToken(): string | null {
        return secureLocalStorage.getItem("refreshToken") as string | null;
    }
    
    removeAccessToken() {
        secureLocalStorage.removeItem("accessToken");
    }
    
    removeRefreshToken() {
        secureLocalStorage.removeItem("refreshToken");
    }
}